// Daire Bazlı İlerleme Takip Verileri — Detaylı Alt Kalemler
// Hiyerarşi: İnşaat → Blok → Kat → Daire → Ana Kalem → Alt Kalem

// ============================================
// Durum tanımları
// ============================================
export const durumlar = {
    baslanmadi: { label: 'Başlanmadı', renk: 'bg-bg-tertiary text-text-muted', dot: 'bg-gray-400' },
    devam_ediyor: { label: 'Devam Ediyor', renk: 'bg-warning/10 text-warning', dot: 'bg-warning' },
    tamamlandi: { label: 'Tamamlandı', renk: 'bg-success/10 text-success', dot: 'bg-success' },
};

// Daire tipleri
export const daireTipleri = [
    '1+0', '1+1', '1+1 Açık Mutfak', '2+1', '2+1 Açık Mutfak',
    '3+1', '3+1 Açık Mutfak', '4+1', '4+1 Dubleks', '5+1',
];

// ============================================
// Ana Kalemler + Alt Kalem Şablonları
// ============================================
// Her ana kalemin altında ne tür alt kalemler olabileceğini tanımlar.
// tip: 'adet' → checkbox bazlı (yapıldı/yapılmadı), 'yuzde' → slider
export const anaKalemSablonlari = [
    {
        id: 'kaba-insaat',
        name: 'Kaba İnşaat',
        ikon: '🏗️',
        kategori: 'yapi',
        sira: 1,
        altKalemler: [
            { id: 'duvar-orme', name: 'Duvar Örme', tip: 'yuzde' },
            { id: 'beton-dokum', name: 'Beton Döküm', tip: 'yuzde' },
            { id: 'sap-cati', name: 'Çatı / Teras', tip: 'yuzde' },
        ],
    },
    {
        id: 'siva-alci',
        name: 'Sıva & Alçı',
        ikon: '🧱',
        kategori: 'yapi',
        sira: 2,
        altKalemler: [
            { id: 'ic-siva', name: 'İç Sıva', tip: 'yuzde' },
            { id: 'dis-siva', name: 'Dış Sıva (Cephe)', tip: 'yuzde' },
            { id: 'alci-salon', name: 'Alçı — Salon', tip: 'adet' },
            { id: 'alci-yatak1', name: 'Alçı — Yatak Odası 1', tip: 'adet' },
            { id: 'alci-yatak2', name: 'Alçı — Yatak Odası 2', tip: 'adet' },
            { id: 'alci-mutfak', name: 'Alçı — Mutfak', tip: 'adet' },
            { id: 'alci-banyo', name: 'Alçı — Banyo', tip: 'adet' },
            { id: 'alci-wc', name: 'Alçı — WC', tip: 'adet' },
        ],
    },
    {
        id: 'elektrik',
        name: 'Elektrik Tesisatı',
        ikon: '⚡',
        kategori: 'tesisat',
        sira: 3,
        altKalemler: [
            { id: 'kablo-cekimi', name: 'Kablo Çekimi', tip: 'yuzde' },
            { id: 'priz-anahtar', name: 'Priz & Anahtar Montajı', tip: 'yuzde' },
            { id: 'aydinlatma-salon', name: 'Aydınlatma — Salon', tip: 'adet' },
            { id: 'aydinlatma-yatak1', name: 'Aydınlatma — Yatak Odası 1', tip: 'adet' },
            { id: 'aydinlatma-yatak2', name: 'Aydınlatma — Yatak Odası 2', tip: 'adet' },
            { id: 'aydinlatma-mutfak', name: 'Aydınlatma — Mutfak', tip: 'adet' },
            { id: 'aydinlatma-banyo', name: 'Aydınlatma — Banyo/WC', tip: 'adet' },
            { id: 'aydinlatma-koridor', name: 'Aydınlatma — Koridor', tip: 'adet' },
            { id: 'aydinlatma-balkon', name: 'Aydınlatma — Balkon', tip: 'adet' },
            { id: 'elektrik-pano', name: 'Elektrik Panosu', tip: 'adet' },
            { id: 'interkom', name: 'İnterkom / Zil Sistemi', tip: 'adet' },
        ],
    },
    {
        id: 'su-tesisati',
        name: 'Su Tesisatı',
        ikon: '🚰',
        kategori: 'tesisat',
        sira: 4,
        altKalemler: [
            { id: 'su-boru-cekimi', name: 'Boru Çekimi (Sıcak/Soğuk)', tip: 'yuzde' },
            { id: 'mutfak-musluk', name: 'Musluk — Mutfak', tip: 'adet' },
            { id: 'banyo-musluk', name: 'Musluk — Banyo', tip: 'adet' },
            { id: 'wc-musluk', name: 'Musluk — WC', tip: 'adet' },
            { id: 'banyo-batarya', name: 'Batarya — Banyo (Duş)', tip: 'adet' },
            { id: 'klozet', name: 'Klozet', tip: 'adet' },
            { id: 'lavabo-banyo', name: 'Lavabo — Banyo', tip: 'adet' },
            { id: 'lavabo-wc', name: 'Lavabo — WC', tip: 'adet' },
            { id: 'dus-kabin', name: 'Duş Kabin / Küvet', tip: 'adet' },
        ],
    },
    {
        id: 'dogalgaz',
        name: 'Doğalgaz Tesisatı',
        ikon: '🔥',
        kategori: 'tesisat',
        sira: 5,
        altKalemler: [
            { id: 'gaz-hatti', name: 'Gaz Hattı Çekimi', tip: 'yuzde' },
            { id: 'kombi', name: 'Kombi Montajı', tip: 'adet' },
            { id: 'radyator-salon', name: 'Radyatör — Salon', tip: 'adet' },
            { id: 'radyator-yatak1', name: 'Radyatör — Yatak Odası 1', tip: 'adet' },
            { id: 'radyator-yatak2', name: 'Radyatör — Yatak Odası 2', tip: 'adet' },
            { id: 'radyator-mutfak', name: 'Radyatör — Mutfak', tip: 'adet' },
            { id: 'radyator-banyo', name: 'Radyatör — Banyo', tip: 'adet' },
        ],
    },
    {
        id: 'seramik-fayans',
        name: 'Seramik & Fayans',
        ikon: '🪟',
        kategori: 'ince',
        sira: 6,
        altKalemler: [
            { id: 'fayans-mutfak', name: 'Fayans — Mutfak Tezgah Arası', tip: 'adet' },
            { id: 'fayans-banyo-duvar', name: 'Fayans — Banyo Duvar', tip: 'adet' },
            { id: 'fayans-banyo-zemin', name: 'Seramik — Banyo Zemin', tip: 'adet' },
            { id: 'fayans-wc-duvar', name: 'Fayans — WC Duvar', tip: 'adet' },
            { id: 'fayans-wc-zemin', name: 'Seramik — WC Zemin', tip: 'adet' },
            { id: 'seramik-balkon', name: 'Seramik — Balkon', tip: 'adet' },
            { id: 'seramik-antre', name: 'Seramik — Antre', tip: 'adet' },
        ],
    },
    {
        id: 'boya',
        name: 'Boya & Badana',
        ikon: '🎨',
        kategori: 'ince',
        sira: 7,
        altKalemler: [
            { id: 'boya-salon', name: 'Boya — Salon', tip: 'adet' },
            { id: 'boya-yatak1', name: 'Boya — Yatak Odası 1', tip: 'adet' },
            { id: 'boya-yatak2', name: 'Boya — Yatak Odası 2', tip: 'adet' },
            { id: 'boya-mutfak', name: 'Boya — Mutfak', tip: 'adet' },
            { id: 'boya-koridor', name: 'Boya — Koridor/Antre', tip: 'adet' },
            { id: 'boya-balkon', name: 'Boya — Balkon', tip: 'adet' },
            { id: 'boya-tavan', name: 'Tavan Boyası (Tüm)', tip: 'yuzde' },
        ],
    },
    {
        id: 'kapi-pencere',
        name: 'Kapı & Pencere',
        ikon: '🚪',
        kategori: 'ince',
        sira: 8,
        altKalemler: [
            { id: 'dis-kapi', name: 'Dış Kapı (Çelik)', tip: 'adet' },
            { id: 'ic-kapi-salon', name: 'İç Kapı — Salon', tip: 'adet' },
            { id: 'ic-kapi-yatak1', name: 'İç Kapı — Yatak Odası 1', tip: 'adet' },
            { id: 'ic-kapi-yatak2', name: 'İç Kapı — Yatak Odası 2', tip: 'adet' },
            { id: 'ic-kapi-mutfak', name: 'İç Kapı — Mutfak', tip: 'adet' },
            { id: 'ic-kapi-banyo', name: 'İç Kapı — Banyo', tip: 'adet' },
            { id: 'ic-kapi-wc', name: 'İç Kapı — WC', tip: 'adet' },
            { id: 'balkon-kapi', name: 'Balkon Kapısı (Cam)', tip: 'adet' },
            { id: 'pencere-pvc', name: 'Pencereler (PVC)', tip: 'yuzde' },
            { id: 'cam-balkon', name: 'Cam Balkon Sistemi', tip: 'adet' },
        ],
    },
    {
        id: 'mutfak',
        name: 'Mutfak',
        ikon: '🍳',
        kategori: 'ince',
        sira: 9,
        altKalemler: [
            { id: 'mutfak-dolap', name: 'Mutfak Dolabı', tip: 'adet' },
            { id: 'tezgah', name: 'Tezgah (Granit/Mermer)', tip: 'adet' },
            { id: 'evye', name: 'Evye', tip: 'adet' },
            { id: 'davlumbaz', name: 'Davlumbaz', tip: 'adet' },
            { id: 'ankastre-set', name: 'Ankastre Set (Fırın+Ocak)', tip: 'adet' },
        ],
    },
    {
        id: 'banyo-wc',
        name: 'Banyo & WC',
        ikon: '🚿',
        kategori: 'ince',
        sira: 10,
        altKalemler: [
            { id: 'banyo-dolap', name: 'Banyo Dolabı + Ayna', tip: 'adet' },
            { id: 'askili-dolap', name: 'WC Dolabı + Ayna', tip: 'adet' },
            { id: 'banyo-aksesuar', name: 'Aksesuarlar (Havluluk, Sabunluk)', tip: 'adet' },
            { id: 'vitrifiye-montaj', name: 'Vitrifiye Montaj Kontrolü', tip: 'adet' },
        ],
    },
    {
        id: 'parke-zemin',
        name: 'Parke & Zemin',
        ikon: '🪵',
        kategori: 'ince',
        sira: 11,
        altKalemler: [
            { id: 'parke-salon', name: 'Parke — Salon', tip: 'adet' },
            { id: 'parke-yatak1', name: 'Parke — Yatak Odası 1', tip: 'adet' },
            { id: 'parke-yatak2', name: 'Parke — Yatak Odası 2', tip: 'adet' },
            { id: 'parke-koridor', name: 'Parke — Koridor', tip: 'adet' },
            { id: 'supra', name: 'Süpürgelik', tip: 'yuzde' },
        ],
    },
    {
        id: 'temizlik-teslim',
        name: 'Temizlik & Teslim',
        ikon: '✨',
        kategori: 'final',
        sira: 12,
        altKalemler: [
            { id: 'kaba-temizlik', name: 'Kaba Temizlik', tip: 'adet' },
            { id: 'ince-temizlik', name: 'İnce Temizlik', tip: 'adet' },
            { id: 'cam-silimi', name: 'Cam Silimi', tip: 'adet' },
            { id: 'genel-kontrol', name: 'Genel Kontrol', tip: 'adet' },
            { id: 'teslim', name: 'Anahtar Teslimi', tip: 'adet' },
        ],
    },
];

// ============================================
// Kat-Daire yapısı (blok bazlı)
// ============================================
export const blokDaireleri = {
    // Yeşil Park - A Blok (4 kat, kat başına 2 daire)
    'b1': {
        katlar: [
            {
                kat: 1, daireler: [
                    { id: 'b1-1-1', no: 'A-101', tip: '2+1', kat: 1 },
                    { id: 'b1-1-2', no: 'A-102', tip: '1+1', kat: 1 },
                ]
            },
            {
                kat: 2, daireler: [
                    { id: 'b1-2-1', no: 'A-201', tip: '2+1', kat: 2 },
                    { id: 'b1-2-2', no: 'A-202', tip: '1+1', kat: 2 },
                ]
            },
            {
                kat: 3, daireler: [
                    { id: 'b1-3-1', no: 'A-301', tip: '3+1', kat: 3 },
                    { id: 'b1-3-2', no: 'A-302', tip: '2+1', kat: 3 },
                ]
            },
            {
                kat: 4, daireler: [
                    { id: 'b1-4-1', no: 'A-401', tip: '3+1', kat: 4 },
                    { id: 'b1-4-2', no: 'A-402', tip: '2+1', kat: 4 },
                ]
            },
        ]
    },
    // Yeşil Park - B Blok
    'b2': {
        katlar: [
            {
                kat: 1, daireler: [
                    { id: 'b2-1-1', no: 'B-101', tip: '2+1', kat: 1 },
                    { id: 'b2-1-2', no: 'B-102', tip: '1+1', kat: 1 },
                ]
            },
            {
                kat: 2, daireler: [
                    { id: 'b2-2-1', no: 'B-201', tip: '2+1', kat: 2 },
                    { id: 'b2-2-2', no: 'B-202', tip: '1+1', kat: 2 },
                ]
            },
            {
                kat: 3, daireler: [
                    { id: 'b2-3-1', no: 'B-301', tip: '3+1', kat: 3 },
                    { id: 'b2-3-2', no: 'B-302', tip: '1+1 Açık Mutfak', kat: 3 },
                ]
            },
            {
                kat: 4, daireler: [
                    { id: 'b2-4-1', no: 'B-401', tip: '3+1', kat: 4 },
                    { id: 'b2-4-2', no: 'B-402', tip: '2+1', kat: 4 },
                ]
            },
        ]
    },
    // Global Rezidans - A Blok (6 kat)
    'b3': {
        katlar: [
            {
                kat: 1, daireler: [
                    { id: 'b3-1-1', no: 'A-101', tip: '3+1', kat: 1 },
                    { id: 'b3-1-2', no: 'A-102', tip: '2+1 Açık Mutfak', kat: 1 },
                ]
            },
            {
                kat: 2, daireler: [
                    { id: 'b3-2-1', no: 'A-201', tip: '3+1', kat: 2 },
                    { id: 'b3-2-2', no: 'A-202', tip: '2+1 Açık Mutfak', kat: 2 },
                ]
            },
            {
                kat: 3, daireler: [
                    { id: 'b3-3-1', no: 'A-301', tip: '3+1 Açık Mutfak', kat: 3 },
                    { id: 'b3-3-2', no: 'A-302', tip: '3+1', kat: 3 },
                ]
            },
            {
                kat: 4, daireler: [
                    { id: 'b3-4-1', no: 'A-401', tip: '3+1 Açık Mutfak', kat: 4 },
                    { id: 'b3-4-2', no: 'A-402', tip: '2+1', kat: 4 },
                ]
            },
            {
                kat: 5, daireler: [
                    { id: 'b3-5-1', no: 'A-501', tip: '4+1', kat: 5 },
                    { id: 'b3-5-2', no: 'A-502', tip: '3+1', kat: 5 },
                ]
            },
            {
                kat: 6, daireler: [
                    { id: 'b3-6-1', no: 'A-601', tip: '4+1 Dubleks', kat: 6 },
                    { id: 'b3-6-2', no: 'A-602', tip: '4+1', kat: 6 },
                ]
            },
        ]
    },
    // Global Rezidans - B Blok
    'b4': {
        katlar: [
            {
                kat: 1, daireler: [
                    { id: 'b4-1-1', no: 'B-101', tip: '3+1', kat: 1 },
                    { id: 'b4-1-2', no: 'B-102', tip: '2+1', kat: 1 },
                ]
            },
            {
                kat: 2, daireler: [
                    { id: 'b4-2-1', no: 'B-201', tip: '3+1', kat: 2 },
                    { id: 'b4-2-2', no: 'B-202', tip: '2+1', kat: 2 },
                ]
            },
            {
                kat: 3, daireler: [
                    { id: 'b4-3-1', no: 'B-301', tip: '3+1 Açık Mutfak', kat: 3 },
                    { id: 'b4-3-2', no: 'B-302', tip: '2+1 Açık Mutfak', kat: 3 },
                ]
            },
            {
                kat: 4, daireler: [
                    { id: 'b4-4-1', no: 'B-401', tip: '3+1', kat: 4 },
                    { id: 'b4-4-2', no: 'B-402', tip: '2+1', kat: 4 },
                ]
            },
            {
                kat: 5, daireler: [
                    { id: 'b4-5-1', no: 'B-501', tip: '4+1', kat: 5 },
                    { id: 'b4-5-2', no: 'B-502', tip: '3+1', kat: 5 },
                ]
            },
            {
                kat: 6, daireler: [
                    { id: 'b4-6-1', no: 'B-601', tip: '4+1 Dubleks', kat: 6 },
                    { id: 'b4-6-2', no: 'B-602', tip: '3+1', kat: 6 },
                ]
            },
        ]
    },
    // Global Rezidans - C Blok
    'b5': {
        katlar: [
            {
                kat: 1, daireler: [
                    { id: 'b5-1-1', no: 'C-101', tip: '3+1 Açık Mutfak', kat: 1 },
                    { id: 'b5-1-2', no: 'C-102', tip: '3+1', kat: 1 },
                ]
            },
            {
                kat: 2, daireler: [
                    { id: 'b5-2-1', no: 'C-201', tip: '3+1 Açık Mutfak', kat: 2 },
                    { id: 'b5-2-2', no: 'C-202', tip: '3+1', kat: 2 },
                ]
            },
            {
                kat: 3, daireler: [
                    { id: 'b5-3-1', no: 'C-301', tip: '4+1', kat: 3 },
                    { id: 'b5-3-2', no: 'C-302', tip: '3+1', kat: 3 },
                ]
            },
            {
                kat: 4, daireler: [
                    { id: 'b5-4-1', no: 'C-401', tip: '4+1', kat: 4 },
                    { id: 'b5-4-2', no: 'C-402', tip: '3+1 Açık Mutfak', kat: 4 },
                ]
            },
            {
                kat: 5, daireler: [
                    { id: 'b5-5-1', no: 'C-501', tip: '4+1 Dubleks', kat: 5 },
                    { id: 'b5-5-2', no: 'C-502', tip: '4+1', kat: 5 },
                ]
            },
            {
                kat: 6, daireler: [
                    { id: 'b5-6-1', no: 'C-601', tip: '5+1', kat: 6 },
                    { id: 'b5-6-2', no: 'C-602', tip: '4+1 Dubleks', kat: 6 },
                ]
            },
        ]
    },
};

// ============================================
// Daire ilerleme verileri üretimi
// ============================================
// Her profile bir inşaat aşamasını temsil eder
const profiles = {
    tamamlanan: { min: 100, max: 100 },
    ilerleyen: { min: 50, max: 100 },
    orta: { min: 20, max: 80 },
    baslangic: { min: 0, max: 40 },
    yeni: { min: 0, max: 0 },
};

// Sabit seed ile pseudo-random (tekrarlanabilir sonuçlar)
const seededRandom = (seed) => {
    let x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
};

const generateDaireIlerleme = (daireId, profileName) => {
    const profile = profiles[profileName];
    const kalemler = anaKalemSablonlari.map((anaKalem, anaIdx) => {
        // Ana kalem sırası arttıkça ilerleme düşer (gerçekçi: kaba önce, boya sonra)
        const siraFactor = Math.max(0, 1 - (anaIdx * 0.08));
        const altKalemDetaylar = anaKalem.altKalemler.map((alt, altIdx) => {
            const seed = daireId.charCodeAt(0) * 100 + anaIdx * 10 + altIdx;
            const rand = seededRandom(seed);
            let deger;
            if (alt.tip === 'adet') {
                // Checkbox: yapıldı (true) veya yapılmadı (false)
                const threshold = ((profile.min + profile.max) / 200) * siraFactor;
                deger = rand < threshold;
            } else {
                // Yüzde: 0-100
                const range = profile.max - profile.min;
                deger = Math.round((profile.min + rand * range) * siraFactor);
                deger = Math.min(100, Math.max(0, Math.round(deger / 5) * 5)); // 5'in katlarına yuvarla
            }
            return {
                altKalemId: alt.id,
                deger, // true/false (adet) veya 0-100 (yuzde)
                tip: alt.tip,
            };
        });

        // Ana kalem yüzdesini alt kalemlerden hesapla
        const toplamAlt = altKalemDetaylar.length;
        const tamamlanan = altKalemDetaylar.reduce((acc, ak) => {
            if (ak.tip === 'adet') return acc + (ak.deger ? 1 : 0);
            return acc + (ak.deger / 100);
        }, 0);
        const anaYuzde = toplamAlt > 0 ? Math.round((tamamlanan / toplamAlt) * 100) : 0;

        let durum = 'baslanmadi';
        if (anaYuzde === 100) durum = 'tamamlandi';
        else if (anaYuzde > 0) durum = 'devam_ediyor';

        return {
            anaKalemId: anaKalem.id,
            yuzde: anaYuzde,
            durum,
            altKalemler: altKalemDetaylar,
        };
    });

    // Genel ilerleme
    const toplam = kalemler.reduce((a, k) => a + k.yuzde, 0);
    const genelIlerleme = Math.round(toplam / kalemler.length);
    let genelDurum = 'baslanmadi';
    if (genelIlerleme === 100) genelDurum = 'tamamlandi';
    else if (genelIlerleme > 0) genelDurum = 'devam_ediyor';

    return { daireId, kalemler, genelIlerleme, durum: genelDurum };
};

// Tüm daireler için ilerleme verileri
export const daireIlerlemeleri = [
    // Yeşil Park A Blok
    generateDaireIlerleme('b1-1-1', 'tamamlanan'),
    generateDaireIlerleme('b1-1-2', 'tamamlanan'),
    generateDaireIlerleme('b1-2-1', 'ilerleyen'),
    generateDaireIlerleme('b1-2-2', 'ilerleyen'),
    generateDaireIlerleme('b1-3-1', 'orta'),
    generateDaireIlerleme('b1-3-2', 'orta'),
    generateDaireIlerleme('b1-4-1', 'baslangic'),
    generateDaireIlerleme('b1-4-2', 'baslangic'),
    // Yeşil Park B Blok
    generateDaireIlerleme('b2-1-1', 'ilerleyen'),
    generateDaireIlerleme('b2-1-2', 'ilerleyen'),
    generateDaireIlerleme('b2-2-1', 'orta'),
    generateDaireIlerleme('b2-2-2', 'orta'),
    generateDaireIlerleme('b2-3-1', 'baslangic'),
    generateDaireIlerleme('b2-3-2', 'baslangic'),
    generateDaireIlerleme('b2-4-1', 'yeni'),
    generateDaireIlerleme('b2-4-2', 'yeni'),
    // Global A Blok
    generateDaireIlerleme('b3-1-1', 'orta'),
    generateDaireIlerleme('b3-1-2', 'orta'),
    generateDaireIlerleme('b3-2-1', 'baslangic'),
    generateDaireIlerleme('b3-2-2', 'baslangic'),
    generateDaireIlerleme('b3-3-1', 'yeni'),
    generateDaireIlerleme('b3-3-2', 'yeni'),
    generateDaireIlerleme('b3-4-1', 'yeni'),
    generateDaireIlerleme('b3-4-2', 'yeni'),
    generateDaireIlerleme('b3-5-1', 'yeni'),
    generateDaireIlerleme('b3-5-2', 'yeni'),
    generateDaireIlerleme('b3-6-1', 'yeni'),
    generateDaireIlerleme('b3-6-2', 'yeni'),
    // Global B Blok
    generateDaireIlerleme('b4-1-1', 'baslangic'),
    generateDaireIlerleme('b4-1-2', 'baslangic'),
    generateDaireIlerleme('b4-2-1', 'yeni'),
    generateDaireIlerleme('b4-2-2', 'yeni'),
    generateDaireIlerleme('b4-3-1', 'yeni'),
    generateDaireIlerleme('b4-3-2', 'yeni'),
    generateDaireIlerleme('b4-4-1', 'yeni'),
    generateDaireIlerleme('b4-4-2', 'yeni'),
    generateDaireIlerleme('b4-5-1', 'yeni'),
    generateDaireIlerleme('b4-5-2', 'yeni'),
    generateDaireIlerleme('b4-6-1', 'yeni'),
    generateDaireIlerleme('b4-6-2', 'yeni'),
    // Global C Blok
    generateDaireIlerleme('b5-1-1', 'yeni'),
    generateDaireIlerleme('b5-1-2', 'yeni'),
    generateDaireIlerleme('b5-2-1', 'yeni'),
    generateDaireIlerleme('b5-2-2', 'yeni'),
    generateDaireIlerleme('b5-3-1', 'yeni'),
    generateDaireIlerleme('b5-3-2', 'yeni'),
    generateDaireIlerleme('b5-4-1', 'yeni'),
    generateDaireIlerleme('b5-4-2', 'yeni'),
    generateDaireIlerleme('b5-5-1', 'yeni'),
    generateDaireIlerleme('b5-5-2', 'yeni'),
    generateDaireIlerleme('b5-6-1', 'yeni'),
    generateDaireIlerleme('b5-6-2', 'yeni'),
];

// ============================================
// Helper fonksiyonlar
// ============================================
export const getDaireIlerleme = (daireId) => {
    return daireIlerlemeleri.find(d => d.daireId === daireId) || null;
};

export const getBlokDaireleri = (blokId) => {
    return blokDaireleri[blokId] || null;
};

export const getBlokIlerlemOzeti = (blokId) => {
    const blok = blokDaireleri[blokId];
    if (!blok) return null;

    const tumDaireler = blok.katlar.flatMap(k => k.daireler);
    const ilerlemeler = tumDaireler.map(d => {
        const il = getDaireIlerleme(d.id);
        return il ? il.genelIlerleme : 0;
    });

    const toplam = ilerlemeler.reduce((a, b) => a + b, 0);
    const ortalama = tumDaireler.length > 0 ? Math.round(toplam / tumDaireler.length) : 0;
    return {
        toplamDaire: tumDaireler.length,
        genelIlerleme: ortalama,
        tamamlanan: ilerlemeler.filter(i => i === 100).length,
        devamEden: ilerlemeler.filter(i => i > 0 && i < 100).length,
        baslamamis: ilerlemeler.filter(i => i === 0).length,
    };
};

export const getInsaatIlerlemeOzeti = (constructionId, bloklar) => {
    const ilgiliBloklar = bloklar.filter(b => b.constructionId === constructionId);
    const ozetler = ilgiliBloklar.map(b => getBlokIlerlemOzeti(b.id)).filter(Boolean);

    const toplamDaire = ozetler.reduce((a, o) => a + o.toplamDaire, 0);
    const toplamIlerleme = ozetler.reduce((a, o) => a + (o.genelIlerleme * o.toplamDaire), 0);
    const ortalama = toplamDaire > 0 ? Math.round(toplamIlerleme / toplamDaire) : 0;

    return {
        toplamDaire,
        genelIlerleme: ortalama,
        tamamlanan: ozetler.reduce((a, o) => a + o.tamamlanan, 0),
        devamEden: ozetler.reduce((a, o) => a + o.devamEden, 0),
        baslamamis: ozetler.reduce((a, o) => a + o.baslamamis, 0),
    };
};

// Tüm daireler listesi (dashboard quick access için)
export const getTumDairelerListesi = () => {
    const list = [];
    Object.entries(blokDaireleri).forEach(([blokId, blok]) => {
        blok.katlar.forEach(kat => {
            kat.daireler.forEach(daire => {
                const il = getDaireIlerleme(daire.id);
                list.push({
                    ...daire,
                    blokId,
                    genelIlerleme: il?.genelIlerleme || 0,
                    durum: il?.durum || 'baslanmadi',
                });
            });
        });
    });
    return list;
};

export default daireIlerlemeleri;
